export const ChecklistActions = {
  // Checklist keys

  GET_CHECKLIST_LIST: "GET_CHECKLIST_LIST",
  SET_CHECKLIST_LIST: "SET_CHECKLIST_LIST",
  GET_CHECKLIST_QUESTION_ANSWER_LIST: "GET_CHECKLIST_QUESTION_ANSWER_LIST",
  SET_CHECKLIST_QUESTION_ANSWER_LIST: "SET_CHECKLIST_QUESTION_ANSWER_LIST",
  DELETE_CHECKLIST_QUESTION: "DELETE_CHECKLIST_QUESTION",
  DELETE_CHECKLIST_QUESTION_SUCCESS: "DELETE_CHECKLIST_QUESTION_SUCCESS",
  GET_CHECKLIST_DEFECTS_LIST: "GET_CHECKLIST_DEFECTS_LIST",
  SET_CHECKLIST_DEFECTS_LIST: "SET_CHECKLIST_DEFECTS_LIST",
  SET_CHECKLIST_LIST_PAGINATION: 'SET_CHECKLIST_LIST_PAGINATION',

  // define other action types here
};
